import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import Card from "components/Card/Card.js";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import config from "config/config.js";

function LanguageSelector(props) {
  const {
    classes,
    // labelAfter,
    // noLabel,
    longLabel,
    language,
    color,
    // classContainer,
    borderBottomStyle,
    selectWidth,
    updateLanguage
  } = props;

  const [open, setOpen] = useState(false);

  const { t, i18n } = useTranslation();

  function handleClick(e) {
    /* ********************
    CAMBIO URL
     ****************** */
    // const url = window.location.pathname;
    // const languages = ["/it/", "/en/"];
    // const shortLanguages = ["/it", "/en"];
    // const contained = languages.some(element => url.includes(element));
    // const shortContained = shortLanguages.some(element =>
    //   url.endsWith(element)
    // );
    // if (contained) {
    //   const language = url.split("/", 2);
    //   let newUrl = url.replace(`/${language[1]}/`, `/${e}/`);
    //   window.location.href = newUrl;
    //   // browserHistory.push(window.location.pathname);
    // } else if (shortContained) {
    //   const language = url.split("/", 2);
    //   const newUrl = url.replace(`/${language[1]}`, `/${e}/`);
    //   window.location.href = newUrl;
    //   // browserHistory.push(window.location.pathname);
    // } else {
    //   const newUrl = `/${e}${url}`;
    //   window.location.href = newUrl;
    //   // browserHistory.push(window.location.pathname);
    // }

    i18n.changeLanguage(e);
    updateLanguage(e);
  }

  const twoLetterLanguages = config.supportedLanguages["2letters"];
  const fourLetterLanguages = config.supportedLanguages["4letters"];
  const allLanguages = twoLetterLanguages.concat(fourLetterLanguages);

  const toggleDrawer = (anchor, open) => () => {
    setOpen(open);
  };

  return (
    <Card className={classes.card} style={{ marginTop: "10px" }}>
      <div className={classes.containerElement}>
        <div className={classes.containerLeft}>
          <span
            style={{
              lineHeight: "40px",
              paddingLeft: "10px"
            }}
          >
            <span className={classes.span}>{t("change_language")}</span>
          </span>
        </div>
        <div className={classes.containerRight}>
          {/* ******* WEB >= 960 ********** */}
          <Hidden smDown implementation="css">
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={language}
              onChange={e => {
                handleClick(e.target.value);
              }}
              style={{
                fontFamily: "'Archivo Narrow', sans-serif",
                margin: "0px",
                color: color,
                borderBottom: borderBottomStyle || "unset",
                width: selectWidth
              }}
              inputProps={{
                name: "simpleSelect",
                id: "simple-select"
              }}
            >
              {allLanguages.map((el, index) => (
                <MenuItem key={`${el} ${index.toString()}`} value={el}>
                  {longLabel ? t(`language_${el}`) : el}
                </MenuItem>
              ))}
            </Select>
          </Hidden>
          {/* ******* MOBILE < 960 ********** */}
          <Hidden mdUp implementation="css">
            <div
              style={{
                textAlign: "right",
                lineHeight: "40px"
              }}
            >
              <Button
                style={{ minWidth: "20px" }}
                onClick={toggleDrawer("bottom", true)}
              >
                {language}
              </Button>
              <SwipeableDrawer
                style={{ zIndex: 9999 }}
                anchor={"bottom"}
                open={open}
                onClose={toggleDrawer("bottom", false)}
                onOpen={toggleDrawer("bottom", true)}
              >
                <List>
                  {["it", "en"].map(text => (
                    <ListItem
                      onClick={() => {
                        handleClick(text);
                        // toggleDrawer("bottom", false);
                        setOpen(false);
                      }}
                      button
                      key={text}
                    >
                      <ListItemText primary={text} />
                    </ListItem>
                  ))}
                </List>
              </SwipeableDrawer>
            </div>
          </Hidden>
        </div>
      </div>
    </Card>
  );
}

LanguageSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  updateLanguage: PropTypes.func.isRequired,
  classContainer: PropTypes.string,
  color: PropTypes.string,
  borderBottomStyle: PropTypes.string,
  selectWidth: PropTypes.string,
  labelAfter: PropTypes.bool,
  noLabel: PropTypes.bool,
  longLabel: PropTypes.bool
};

LanguageSelector.defaultProps = {
  classContainer: "language-selector",
  color: "#000000",
  borderBottomStyle: "",
  selectWidth: "initial",
  labelAfter: false,
  noLabel: false,
  longLabel: false
};

export default withStyles(dashboardStyle)(LanguageSelector);
